import logo from "./logo_offwhite.png"
export default function BasicInput(props) {
  return <>
      <img style={{cursor: "pointer"}} onClick={()=>{window.open("https://bit.ly/GM-KOTC");}} src={logo} className={props.className} alt="logo" />
    </>
}
